export const freeEmailDomains = [
  "gmail.com",
  "yahoo.com",
  "hotmail.com",
  "outlook.com",
  "live.com",
  "msn.com",
  "icloud.com",
  "aol.com",
  "proton.me",
  "protonmail.com",
  "yandex.com",
  "gmx.com",
  "mail.com",
  "zoho.com",
  "googlemail.com",
  "me.com",
  "pm.me",
  "yahoo.co.uk",
  "hotmail.co.uk",
  "outlook.co.uk",
  "live.co.uk",
];

// Fast membership test; keep array export for compatibility
export const FREE_EMAIL_DOMAINS = new Set(freeEmailDomains);

export const isBusinessEmail = (email: string) => {
  const trimmed = email.trim().toLowerCase();
  const basic = /^[^\s@]+@[^\s@]+\.[A-Za-z]{2,}$/.test(trimmed);
  if (!basic) return false;
  const domain = trimmed.split("@")[1] ?? "";
  return !FREE_EMAIL_DOMAINS.has(domain);
};
